
import axios from "axios";
const axiosInstance = axios.create({
  baseURL: "https://api.rentexcel.com/",  // live: 13.207.215.230
  // baseURL: "https://api-uat.rentexcel.com/", //35.154.66.81
  // baseURL: "https://api-uat.taprootcrm.com/",
  // baseURL: "http://192.168.0.181:4567",
  
  // baseURL: "http://192.168.1.10:4567", // HK
});

// Set document title dynamically based on the active API URL
if (axiosInstance.defaults.baseURL && axiosInstance.defaults.baseURL.includes("rentexcel")) {
  document.title = "CC RentExcel CRM";
} else {
  document.title = "CC Taproot CRM";
}

// Add a request interceptor to attach the token from localStorage
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Retrieve the token from localStorage
  if (token) {
    config.headers["Authorization"] = `Token ${token}`; // Add the token to the request headers
  }
 
  config.headers["domain"] = "central";
  // config.headers["domain"] = window.location.hostname.replace(
  //   /\bdashboard.\b/g,
  //   ""
  // );
  return config;
});

// Legal and policy URLs based on active API environment
export const getLegalUrls = () => {
  const baseURL = axiosInstance.defaults.baseURL || "";
  const isUat = baseURL.includes("uat");
  const host = isUat ? "https://uat.rentexcel.com" : "https://rentexcel.com";
  return {
    privacyPolicy: `${host}/privacy-policy`,
    termsOfService: `${host}/terms-of-service`,
  };
};

export const LEGAL_URLS = getLegalUrls();
axiosInstance.legalUrls = LEGAL_URLS;

export default axiosInstance;
